import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

import TopButton from "components/topbutton/TopButton";
import "styles/scss/table.scss";
import * as EgovNet from 'api/fetch';

import { itemIdxByPage } from 'utils/calc';
import Pagination from 'components/Pagination';
import { getSessionItem } from 'utils/storage';

function Pst() {
    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
    const location = useLocation();
    const cndRef = useRef();
    const wrdRef = useRef();
    const navigate = useNavigate();
    const [searchCondition, setSearchCondition] = useState(location.state?.searchCondition || { pageIndex: 1, searchCnd: "", searchWrd: "" });
    const [paginationInfo, setPaginationInfo] = useState({});
    const [listTag, setListTag] = useState([]);
    const [cnt, setCnt] = useState();
    const [pageInput, setPageInput] = useState(searchCondition.pageIndex);
    const [ctgryList, setCtgryList] = useState([]);
    
    const sessionUser = getSessionItem('loginUser');
    const sessionUserId = sessionUser?.id;
    const sessionUserNm = sessionUser?.name;

    // 텍스트만 가져오는 함수
    const formatText = (text) => {
        if(!text) return "-"; // null 값 처리
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        return doc.body.textContent || "-"; // 텍스트가 없을 경우 "-" 반환
    };

    // 날짜 연월일 시:분 형식으로 변경하는 함수
    const formatDate = (dateString) => {
        if(!dateString) return "-"; // null 값 처리
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };


    const retrieveList = useCallback((searchCondition) => {
        const retrieveListURL = '/api/psts' + EgovNet.getQueryString(searchCondition);
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
            }
        }
        EgovNet.requestFetch(retrieveListURL, requestOptions, (resp) => {
            setPaginationInfo(resp.result.paginationInfo);
            let mutListTag = [];
            const resultCnt = parseInt(resp.result.resultCnt);
            const currentPageNo = resp.result.paginationInfo.currentPageNo;
            const pageSize = resp.result.paginationInfo.pageSize;

            setCtgryList(resp.result.ctgry.resultList);
            resp.result.resultList.forEach(function (item, index) {
                if (index === 0) mutListTag = [];
                const listIdx = itemIdxByPage(resultCnt, currentPageNo, pageSize, index);
                mutListTag.push(
                    <tr key={`${item.pstId}-${index}`} onClick={handleRowClick(item.pstId, item.regId)}>
                        <td>{listIdx}</td>
                        <td>{item.ctgryNm}</td>
                        <td>{item.pstTtl}</td>
                        {/* 텍스트만 가져오기 */}                        
                        <td>{formatText(item.pstCn)}</td>
                        <td>{formatDate(item.regDt)}</td>
                        <td>{item.regNm}</td>
                        <td>{item.pstInqCnt}</td>                            
                    </tr>
                );
            });
            if (!mutListTag.length) {
                mutListTag.push(
                    <tr key="0">
                        <td colSpan="7" className="no_data">검색된 결과가 없습니다.</td>
                    </tr>
                );
            }
            setListTag(mutListTag);
            setCnt(resp.result.resultCnt);
        },
        (resp) => {
            console.log("err response : ", resp);
        });
    }, []);

    useEffect(() => {
        retrieveList(searchCondition);
    }, [searchCondition, retrieveList]);

    const handleRowClick = (pstId, regId) => () => {
        // 작성글만 상세보기 가능
        if (sessionUserId !== regId) {
            alert("작성자만 조회,수정,삭제가 가능합니다.");
            return;
        }      
        navigate(`/pst/${pstId}`);
    };

    const handleSearch = () => {
        if (wrdRef.current) {
            setSearchCondition({ ...searchCondition, pageIndex: 1, searchCnd: cndRef.current.value, searchWrd: wrdRef.current.value });
        } else {
            console.error("wrdRef.current is undefined");
        }
    };

    const handleReset = () => {
        cndRef.current.value = '';
        cndRef.current.value = '';
        setSearchCondition({ ...searchCondition, pageIndex: 1, searchCnd: '', searchWrd: '' });
    };

    const handleLogout = () => {
        sessionStorage.removeItem('loginUser');
        localStorage.removeItem('KEY_NM');
        // logout 후 홈으로 이동
        navigate('/');
    }

    const handleBtnAdd = () => {
        navigate('/pst');
    };

    const handlePageMove = () => {
        const pageInput = document.getElementById("pageInput");
        const pageNumber = parseInt(pageInput.value, 10);

        if (!isNaN(pageNumber) && pageNumber > 0 && pageNumber <= paginationInfo.totalPageCount) {
            setSearchCondition({ ...searchCondition, pageIndex: pageNumber });
        } else {
            alert("유효한 페이지 번호를 입력하세요.");
        }
    };

    return (    
        <>
            <div className="new">
                <TopButton />
                <div className="news-background">
                    <h1>게시글관리</h1>
                    <p>[ 비즈니스 / N소식 ]</p>
                    {/* 브레드크럼 */}
                    <div className="breadcrumb-box container">
                    <nav className="breadcrumb">
                        <ul>
                            <li className="home-icon">
                            <Link to="/">
                                <span className="home"></span>
                            </Link>
                            </li>
                            <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                                게시글관리
                                <span className="dropdown-icon">
                                    {isCompanyDropdownOpen ? "▲" : "▼"}
                                </span>
                                {isCompanyDropdownOpen && (
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link to="/about">회사소개</Link>
                                        </li>
                                        <li>
                                            <Link to="/business">비즈니스</Link>
                                        </li>
                                        <li>
                                            <Link to="/news">N소식</Link>
                                        </li>
                                        <li>
                                            <Link to="/recruitment">인재채용</Link>
                                        </li>
                                        <li>
                                            <Link to="/table">게시글관리</Link>
                                        </li>
                                    </ul>
                                )}
                                </li>
                        </ul>
                    </nav>
                    <div className="mobile">
                        <ul>
                            <li className="home-icon">
                                <Link to="/">
                                    <span className="home"></span>
                                </Link>
                            </li>
                            <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                                    게시글관리
                                <span className="dropdown-icon">
                                    {isCompanyDropdownOpen ? "▲" : "▼"}
                                </span>
                                {isCompanyDropdownOpen && (
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link to="/about">회사소개</Link>
                                        </li>
                                        <li>
                                            <Link to="/business">비즈니스</Link>
                                        </li>
                                        <li>
                                            <Link to="/news">N소식</Link>
                                        </li>
                                        <li>
                                            <Link to="/recruitment">인재채용</Link>
                                        </li>
                                        <li>
                                        <Link to="/table">게시글관리</Link>
                                        </li>
                                    </ul>
                                )}
                                </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    <div className="container admin-contents">
                    <div className="btn-flex">
                        <div className="search-box">
                            <select className="form-select"
                                id="searchCnd" name="searchCnd" title="검색조건"
                                ref={cndRef}
                                onChange={e => {
                                    cndRef.current.value = e.target.value;
                                }}
                            >
                                <option value="">선택</option>
                                {ctgryList.map((option, i) => {
                                    return (
                                    <option value={option.ctgry} key={i}>{option.ctgryNm}</option>
                                    )
                                })}
                            </select>
                            <input type="text" className="search-input form-control" placeholder="검색어를 입력하세요."
                                name="searchWrd" id="searchWrd" title="검색어"
                                ref={wrdRef}
                                onChange={e => {
                                    wrdRef.current.value = e.target.value;
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSearch(); // 엔터 키 입력 시 검색 실행
                                    }
                                }}
                            />
                            <button className="search-button btn">
                                <span className="search-img" onClick={handleSearch}></span>
                            </button>
                            <span className="search-line"></span>
                            <button className="reset-btn btn">
                                <span className="reset-img" onClick={handleReset}></span>
                            </button>
                        </div>
                        <div className="sessionAndOut">
                            <div>접속계정 : <a href="/mypage">{sessionUserId}({sessionUserNm})</a></div>
                            <div className="logOut">
                                <button type="button" className="btn logOut-btn" onClick={handleLogout}>
                                    <span></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="session-box">
                        <p>{cnt}건</p>
                        <button type="button" className="btn btn-submit" onClick={handleBtnAdd}>등록</button>
                    </div>
                    <div className="table-container">
                        <table className="admin-table">
                            <colgroup>
                                <col width={"5%"}></col>
                                <col width={"20%"}></col>
                                <col width={"10%"}></col>
                                <col width={"30%"}></col>
                                <col width={"15%"}></col>
                                <col width={"15%"}></col>
                                <col width={"5%"}></col>
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>번호</th>
                                    <th>카테고리</th>
                                    <th>제목</th>
                                    <th>내용</th>
                                    <th>등록일자</th>
                                    <th>등록자</th>
                                    <th>조회수</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listTag}
                            </tbody>
                        </table>
                    </div>                    
                    <div className="pagination-group">
                        <div></div>
                        <Pagination pagination={paginationInfo} moveToPage={(passedPage) => {
                                setSearchCondition({ ...searchCondition, pageIndex: passedPage, searchCnd: cndRef.current.value, searchWrd: wrdRef.current.value })
                                setPageInput(passedPage);
                            }}
                        />
                        <div className="pageInfo">
                            <input type="text"
                                id="pageInput"
                                value={pageInput}
                                min="1"
                                max={paginationInfo.totalPageCount}
                                onChange={e => {
                                    const value = e.target.value.replace(/[^0-9]/g, ""); // 숫자만 허용
                                    setPageInput(value); // 상태 업데이트
                                }}
                            />
                            <span>/ {paginationInfo.totalPageCount}</span>
                            <button onClick={handlePageMove}>이동</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Pst;